<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-09-27 17:36:49
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-09-27 17:38:24
-->
<template>
	<div>{{ cellValue | formatEmpty | formatPrice }}</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';

export default {
	name: 'PriceCell',
	mixins: [mixin],
};
</script>
